<template>
  <div class="msg picture">
    <el-image
      class="img__pic"
      :src="imgeMessageItem.imgsrc"
      :preview-src-list="[imgeMessageItem.imgsrc]"
      hide-on-click-modal
    />
  </div>
</template>
<script>
import { computed } from "vue";

export default {
  props: {
    msgItem: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const imgeMessageItem = computed(() => props.msgItem);

    return { imgeMessageItem };
  },
};
</script>
